<script setup>
import {computed, inject, ref, watch} from 'vue'

const props = defineProps({
    containerRef: {
        type: String,
        required: true
    },
    uuid: {
        type: String,
        require: true
    },
    content: {
        type: Object,
        required: true
    },
});

const fieldUuid = computed(() => props.content.uuid);
const title = computed(() => props.content.title);
const required = computed(() => props.content.required);
const _allowCustomAnswer = computed(() => props.content.allowCustomAnswer);

const options = computed(() => {
    return props.content.alternatives.map((alternative) => {
        return {
            label: alternative.title,
            value: alternative.title
        }
    });
});

const formDatastore = inject('formDatastore');
const fieldValue = ref(null)
watch(() => fieldValue.value, (value) => {
    formDatastore.fields[props.uuid] = value;
});

</script>

<template>
    <div class="relative">
        <input
            type="hidden"
            :name="`data[${uuid}][block_uuid]`"
            :value="fieldUuid"
        />
        <input
            type="hidden"
            :name="`data[${uuid}][type]`"
            value="array"
        />
        <input-checkboxes
            :name="`data[${uuid}][value]`"
            :label="title"
            :options="options"
            :required="required"
            :allow-custom-answer="_allowCustomAnswer"
            v-model:content="fieldValue"
        />
        <page-builder-block-view-forms-sidebar
            v-if="content.showInstructions"
            :container-ref="containerRef"
            :uuid="uuid"
            :content="content"
        />
    </div>
</template>
